// Map of specific MIME types to Font Awesome v6 icons
const fileIconMap: { [key: string]: string } = {
    // Documents
    'application/pdf': 'fa-light fa-file-pdf',
    'application/msword': 'fa-light fa-file-word',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        'fa-light fa-file-word',
    'application/vnd.ms-excel': 'fa-light fa-file-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'fa-light fa-file-excel',
    'application/vnd.ms-powerpoint': 'fa-light fa-file-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation':
        'fa-light fa-file-powerpoint',
    'text/plain': 'fa-light fa-file-lines',
    'text/csv': 'fa-light fa-file-csv',
    'text/html': 'fa-light fa-file-code',
    'text/xml': 'fa-light fa-file-code',
    'application/json': 'fa-light fa-file-code',

    // Archives
    'application/zip': 'fa-light fa-file-zipper',
    'application/x-rar-compressed': 'fa-light fa-file-zipper',
    'application/x-7z-compressed': 'fa-light fa-file-zipper',
    'application/x-tar': 'fa-light fa-file-zipper',

    // Images
    'image/jpeg': 'fa-light fa-file-image',
    'image/png': 'fa-light fa-file-image',
    'image/gif': 'fa-light fa-file-image',
    'image/svg+xml': 'fa-light fa-file-image',
    'image/webp': 'fa-light fa-file-image',

    // Audio
    'audio/mpeg': 'fa-light fa-file-audio',
    'audio/wav': 'fa-light fa-file-audio',
    'audio/ogg': 'fa-light fa-file-audio',

    // Video
    'video/mp4': 'fa-light fa-file-video',
    'video/x-msvideo': 'fa-light fa-file-video',
    'video/x-matroska': 'fa-light fa-file-video',
};

// Fallbacks by general MIME type
const fallbackMap: { [key: string]: string } = {
    image: 'fa-light fa-file-image',
    audio: 'fa-light fa-file-audio',
    video: 'fa-light fa-file-video',
    text: 'fa-light fa-file-lines',
    application: 'fa-light fa-file',
};

// Function to get icon for MIME type
export function getFileIcon(mimeType?: string): string {
    if (!mimeType) {
        return 'fa-light fa-file';
    }
    
    if (fileIconMap[mimeType]) {
        return fileIconMap[mimeType];
    }

    const topLevelType = mimeType.split('/')[0];
    if (fallbackMap[topLevelType]) {
        return fallbackMap[topLevelType];
    }

    return 'fa-light fa-file'; // ultimate fallback
}
